(function () {
  'use strict';

  if (window.__routineProgressInit) return;
  window.__routineProgressInit = true;

  const CART_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js';
  const CART_ADD_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
  const CART_CHANGE_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/change.js';

  let cachedCartIds = null;
  let inFlightFetch = null;

  function waitForCartHelper() {
    try {
      if (window.Alpine && Alpine.store && Alpine.store('xCartHelper') && typeof Alpine.store('xCartHelper').waitForCartUpdate === 'function') {
        return Alpine.store('xCartHelper').waitForCartUpdate();
      }
    } catch (e) {}
    return Promise.resolve();
  }

  function fetchCartProductIds(forceRefresh) {
    if (!forceRefresh && cachedCartIds) return Promise.resolve(cachedCartIds);
    if (inFlightFetch) return inFlightFetch;
    const url = CART_URL + '?_=' + Date.now();
    inFlightFetch = waitForCartHelper()
      .then(function () {
        return fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const ids = new Set();
        (cart.items || []).forEach(function (item) {
          if (item.product_id != null) ids.add(String(item.product_id));
        });
        cachedCartIds = ids;
        return ids;
      })
      .catch(function () {
        return new Set();
      })
      .finally(function () {
        inFlightFetch = null;
      });
    return inFlightFetch;
  }

  function applyState(root, cartIds) {
    const total = parseInt(root.getAttribute('data-routine-total'), 10) || 0;
    const missingTpl = root.getAttribute('data-routine-missing-template') || '';
    let inCartCount = 0;

    root.querySelectorAll('[data-routine-step]').forEach(function (step) {
      const id = step.getAttribute('data-product-id');
      const inCart = id && cartIds.has(String(id));
      step.setAttribute('data-in-cart', inCart ? 'true' : 'false');
      if (inCart) inCartCount++;
    });

    root.querySelectorAll('[data-routine-dot]').forEach(function (dot) {
      const id = dot.getAttribute('data-product-id');
      const inCart = id && cartIds.has(String(id));
      dot.setAttribute('data-in-cart', inCart ? 'true' : 'false');
    });

    const countEl = root.querySelector('[data-routine-count]');
    if (countEl) countEl.textContent = String(inCartCount);

    const missing = Math.max(0, total - inCartCount);
    const missingEl = root.querySelector('[data-routine-missing]');
    if (missingEl) {
      if (missing > 0 && missingTpl) {
        missingEl.textContent = missingTpl.replace('{missing}', String(missing));
        missingEl.style.display = '';
      } else {
        missingEl.textContent = '';
        missingEl.style.display = 'none';
      }
    }

    const cta = root.querySelector('[data-routine-cta]');
    if (cta) cta.style.display = missing > 0 ? '' : 'none';
  }

  function refreshAll(forceRefresh) {
    return fetchCartProductIds(forceRefresh).then(function (cartIds) {
      document.querySelectorAll('[data-routine-progress]').forEach(function (root) {
        applyState(root, cartIds);
      });
    });
  }

  function handleAddClick(event) {
    const btn = event.target.closest('[data-routine-add]');
    if (!btn) return;
    const step = btn.closest('[data-routine-step]');
    if (!step) return;

    const variantId = step.getAttribute('data-variant-id');
    const productUrl = step.getAttribute('data-product-url');

    if (!variantId) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    event.preventDefault();
    btn.setAttribute('disabled', 'true');

    let body;
    let sectionsToRender = [];
    try {
      if (window.Alpine && Alpine.store && Alpine.store('xCartHelper') && typeof Alpine.store('xCartHelper').getSectionsToRender === 'function') {
        sectionsToRender = Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}

    body = JSON.stringify({
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      sections: sectionsToRender
    });

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (productUrl) window.location.href = productUrl;
          return;
        }
        try {
          if (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) {
            const helper = Alpine.store('xCartHelper');
            if (res.data && res.data.sections && typeof helper.reRenderSections === 'function') {
              helper.reRenderSections(res.data.sections);
            }
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) helper.currentItemCount = parseInt(bubble.innerHTML, 10);
          }
          if (window.Alpine && Alpine.store && Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
            Alpine.store('xCartNoti').setItem(res.data);
          } else if (window.Alpine && Alpine.store && Alpine.store('xMiniCart') && typeof Alpine.store('xMiniCart').openCart === 'function') {
            Alpine.store('xMiniCart').openCart();
          }
        } catch (e) {}

        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      })
      .catch(function () {
        if (productUrl) window.location.href = productUrl;
      })
      .finally(function () {
        btn.removeAttribute('disabled');
      });
  }

  function handleRemoveClick(event) {
    const btn = event.target.closest('[data-routine-remove]');
    if (!btn) return;
    const step = btn.closest('[data-routine-step]');
    if (!step) return;

    const variantId = step.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();
    btn.setAttribute('disabled', 'true');

    let sectionsToRender = [];
    try {
      if (window.Alpine && Alpine.store && Alpine.store('xCartHelper') && typeof Alpine.store('xCartHelper').getSectionsToRender === 'function') {
        sectionsToRender = Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}

    fetch(CART_CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: 0, sections: sectionsToRender })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        try {
          if (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) {
            const helper = Alpine.store('xCartHelper');
            if (res.data && res.data.sections && typeof helper.reRenderSections === 'function') {
              helper.reRenderSections(res.data.sections);
            }
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) helper.currentItemCount = parseInt(bubble.innerHTML, 10);
          }
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      })
      .catch(function () {})
      .finally(function () {
        btn.removeAttribute('disabled');
      });
  }

  function init() {
    if (!document.querySelector('[data-routine-progress]')) return;
    refreshAll(true);
    document.addEventListener('eurus:cart:items-changed', function () {
      cachedCartIds = null;
      setTimeout(function () { refreshAll(true); }, 80);
    });
    document.addEventListener('click', handleAddClick);
    document.addEventListener('click', handleRemoveClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
